import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VehicleTypeTonsService } from 'orchestrator';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  VehicleTypeTonsCreateDto,
  VehicleTypeTonsDto,
  VehicleTypeTonsExcelDownloadDto,
  VehicleTypeTonsUpdateDto,
} from '../proxy/controlling/dtos/vehicle-type-tons';
import { VEHICLETYPETONS_CONFIG, VEHICLETYPETONS_FIELDS } from './vehicle-type-tons.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-vehicle-type-tons',
  imports: [
    CommonModule,
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, VehicleTypeTonsService, ConfirmationService],
  templateUrl: './vehicle-type-tons.html',
  styleUrl: './vehicle-type-tons.scss',
})
export class VehicleTypeTons extends BaseHierarchicalCrudComponent<
  VehicleTypeTonsDto,
  VehicleTypeTonsCreateDto,
  VehicleTypeTonsUpdateDto,
  VehicleTypeTonsExcelDownloadDto
> {
  service = inject(VehicleTypeTonsService);
  config = VEHICLETYPETONS_CONFIG;
  fields = VEHICLETYPETONS_FIELDS;

  protected prepareUpdateDto(data: any, selected: VehicleTypeTonsDto): VehicleTypeTonsUpdateDto {
    return {
      ...data,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'VehicleTypeTons';
  }
}
